import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { StokvelMembersPanel } from './StokvelMembersPanel';
import { StokvelWithdrawalsPanel } from './StokvelWithdrawalsPanel';
import { StokvelReportPanel } from './StokvelReportPanel';
import { StokvelSettingsPanel } from './StokvelSettingsPanel';
import { StokvelReconPanel } from './StokvelReconPanel';

export const AdminStokvelTab = () => {
  const [tab, setTab] = useState('members');
  return (
    <div className="bg-white rounded-xl shadow-md border border-stone-200 p-6 min-w-0 overflow-hidden" data-testid="admin-stokvel-tab">
      <h2 className="text-2xl font-bold text-stone-800">TMC Stokvel</h2>
      <p className="text-sm text-stone-600 mt-1 mb-4">Applications, members, emergency withdrawals and payout reporting.</p>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="members" data-testid="stokvel-admin-tab-members">Applications &amp; Members</TabsTrigger>
          <TabsTrigger value="withdrawals" data-testid="stokvel-admin-tab-withdrawals">Emergency withdrawals</TabsTrigger>
          <TabsTrigger value="recon" data-testid="stokvel-admin-tab-recon">Interest &amp; Recon</TabsTrigger>
          <TabsTrigger value="report" data-testid="stokvel-admin-tab-report">Report</TabsTrigger>
          <TabsTrigger value="settings" data-testid="stokvel-admin-tab-settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="members" className="mt-4"><StokvelMembersPanel /></TabsContent>
        <TabsContent value="withdrawals" className="mt-4"><StokvelWithdrawalsPanel /></TabsContent>
        <TabsContent value="recon" className="mt-4"><StokvelReconPanel /></TabsContent>
        <TabsContent value="report" className="mt-4"><StokvelReportPanel /></TabsContent>
        <TabsContent value="settings" className="mt-4"><StokvelSettingsPanel /></TabsContent>
      </Tabs>
    </div>
  );
};
